'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _index = require('components/formComponents/index');

var _reduxForm = require('redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddContactForm = (_dec = (0, _reduxForm.reduxForm)({
  form: 'addContactForm',
  propNamespace: 'addContactForm',
  initialValues: {
    name: '',
    surname: ''
  }
}), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(AddContactForm, _PureComponent);

  function AddContactForm() {
    (0, _classCallCheck3.default)(this, AddContactForm);
    return (0, _possibleConstructorReturn3.default)(this, (AddContactForm.__proto__ || (0, _getPrototypeOf2.default)(AddContactForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddContactForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loading = _props.loading,
          onSubmit = _props.onSubmit,
          _props$addContactForm = _props.addContactForm,
          handleSubmit = _props$addContactForm.handleSubmit,
          submitting = _props$addContactForm.submitting,
          invalid = _props$addContactForm.invalid;
      var t = this.context.t;

      var showLoader = submitting || loading;

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(onSubmit) },
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)(className) },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'name',
            type: 'text',
            autoFocus: true,
            fieldClassName: 'width-perc-100',
            placeholder: t('First Name') + '*',
            hideLabel: true,
            component: _index.formSimpleTextInput,
            required: true
          }),
          _react2.default.createElement(_reduxForm.Field, {
            name: 'surname',
            type: 'text',
            fieldClassName: 'width-perc-100',
            placeholder: t('Last Name') + '*',
            hideLabel: true,
            component: _index.formSimpleTextInput,
            required: true
          }),
          _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _react2.default.createElement(
              _Button2.default,
              {
                type: 'submit',
                className: 'btn-default wide pos-rel',
                disabled: invalid,
                loading: showLoader
              },
              t('Add')
            )
          )
        )
      );
    }
  }]);
  return AddContactForm;
}(_react.PureComponent), _class2.propTypes = {
  addContactForm: _propTypes2.default.object,
  className: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onSubmit: _propTypes2.default.func
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  onSubmit: _noop3.default
}, _temp)) || _class);
exports.default = AddContactForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddContact/AddContactForm/AddContactForm.js
// module id = 1941
// module chunks = 1